<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  selectedCount: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(['cancel', 'forward']);

const { t } = useI18n();

const canForward = computed(() => props.selectedCount > 0);
</script>

<template>
  <div
    class="sticky top-0 z-50 bg-gradient-to-r from-woot-500 to-woot-600 dark:from-woot-600 dark:to-woot-700 text-white shadow-lg border-b border-woot-700 dark:border-woot-800 transition-all duration-300 animate-in slide-in-from-top"
  >
    <div class="flex items-center justify-between px-4 py-3">
      <div class="flex items-center gap-4">
        <button
          type="button"
          class="p-2 rounded-full hover:bg-white/20 active:bg-white/30 transition-all duration-200 flex items-center justify-center"
          :aria-label="t('GENERAL.CLOSE')"
          @click="emit('cancel')"
        >
          <i class="i-lucide-x w-5 h-5" />
        </button>
        <div class="flex items-center gap-2">
          <div
            class="bg-white/20 backdrop-blur-sm rounded-full px-3 py-1 flex items-center gap-2 animate-in fade-in zoom-in duration-300"
          >
            <i class="i-lucide-check-square w-4 h-4" />
            <span class="text-sm font-semibold">
              {{ selectedCount }}
            </span>
          </div>
          <span class="text-sm font-medium opacity-90">
            {{
              selectedCount === 1
                ? t('MESSAGE_SELECTION.SINGLE_SELECTED')
                : t('MESSAGE_SELECTION.COUNT', { count: selectedCount })
            }}
          </span>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <button
          type="button"
          class="px-4 py-2 text-sm font-semibold rounded-lg bg-white text-woot-600 hover:bg-slate-50 active:bg-slate-100 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white transition-all duration-200 flex items-center gap-2 shadow-sm hover:shadow-md disabled:shadow-none"
          :disabled="!canForward"
          @click="emit('forward')"
        >
          <i class="i-lucide-share w-4 h-4" />
          <span>{{ t('FORWARD_MODAL.SUBMIT') }}</span>
        </button>
      </div>
    </div>
  </div>
</template>
